const AccountTypes = {
    POSTPAID : 'POST-PAID',
    PREPAID : 'PRE-PAID'
}

export default AccountTypes